import axios from 'axios';
import { put } from 'redux-saga/effects';

import { apiEndpoints } from '../../../config/config';
import { Creators } from './actions';

// *************************** Fetch Reviews Banner Saga ***************************
export function* fetchT3BannerSaga(action) {
  try {
    yield put(Creators.fetchT3BannerStart());
    // Change the apiEndpoint below this line
    const url = yield apiEndpoints.t3BannerData;
    // console.log('url: ', url);
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const t3BannerData = [];
    if (res.status === 200) {
      // if (res.data.success === 1) {
      for (let key in res.data.Banner) {
        t3BannerData.push({
          id: key,
          ...res.data.Banner[key]
        });
      }
    }
    // console.log('t3BannerData: ', t3BannerData);
    yield put(Creators.fetchT3BannerSuccess(t3BannerData));
  } catch (err) {
    yield put(Creators.fetchT3BannerFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Latest Reviews Saga ***************************
export function* fetchLatestT3Saga(action) {
  try {
    yield put(Creators.fetchLatestT3Start());
    let url;
    if (action.pageNumber === 1) {
      url = yield apiEndpoints.t3Latest;
      // url = yield apiEndpoints.latestT3;
    } else {
      url = yield `${apiEndpoints.t3Latest}/page/${action.pageNumber}`;
      // url = yield `${apiEndpoints.latestT3}/page/${action.pageNumber}`;
    }
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const latestT3 = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        latestT3.push({
          id: res.data.categoryPosts[key].postId,
          ...res.data.categoryPosts[key]
        });
      }
    }
    yield put(
      Creators.fetchLatestT3Success({
        pageNumber: action.pageNumber,
        latestT3
      })
    );
  } catch (err) {
    yield put(Creators.fetchLatestT3Failure(err));
  }
}
// ______________________________________________________________________________
